import { connect } from 'react-redux';
import LimitTransferMoney from '../component/LimitTransferMoney';
import actionSetting from '../redux/actions/setting_data/index';
import actionAdmin from '../redux/actions/admin';
import actionTran from '../redux/actions/transactions';

const mapStateToProps = (state) => ({
  coins: state.setting.coins,
  arrCoins: state.setting.arrCoins,
  adminInfo: state.admin.adminInfo,
  limitWithdrawals: state.admin.limitWithdrawals,
  trans: state.transaction.trans,
});

const mapDispatchToProps = (dispatch) => ({
//   userListAction: (params, callback) => {
//     dispatch(actions.userListAction(params, callback));
//   },
  selectCoin: (coin) => {
    dispatch(actionSetting.selectCoin(coin));
  },
  fetchAdminInfo: (params) => {
    dispatch(actionAdmin.onFetchAdminInfo(params));
  },

  fetchLimitWithdrawalOfAdminAction: (params) => {
    dispatch(actionAdmin.fetchLimitWithdrawalOfAdminAction(params));
  },

  fetchSetLimitWithdrawal: (params, callback) => {
    dispatch(actionAdmin.setLimitWithdrawalForAdminAction(params, callback));
  },
  onFetchUserTransHistoryAction: (params, callback) => {
    dispatch(actionTran.fetchUserTransHistoryAction(params, callback));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(LimitTransferMoney);
